import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';
import {RootState} from '@store';
import {systemsAPI} from '@api/methods';
import {IDLE, PENDING} from '@constants/loadingState';
import {ISnapshot} from '@types';

type CompareState = {
  loading: string;
  data: ISnapshot | null;
  error: string | null;
};

const initialState: CompareState = {
  loading: IDLE,
  data: null,
  error: null,
};

export const getSystemSnapshotsRangeThunk = createAsyncThunk<
  ISnapshot,
  {system_id: string; before_snapshot_id: string; after_snapshot_id: string},
  {state: RootState}
>(
  'compare/getSystemSnapshotsRange',
  async ({system_id, before_snapshot_id, after_snapshot_id}) => {
    const data = await systemsAPI.getSystemSnapshotsRange(
      system_id,
      before_snapshot_id,
      after_snapshot_id,
    );
    return data as ISnapshot;
  },
);

const compareSlice = createSlice({
  name: 'compare',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(getSystemSnapshotsRangeThunk.pending, state => {
      state.loading = PENDING;
      state.error = null;
    });
    builder.addCase(getSystemSnapshotsRangeThunk.fulfilled, (state, action) => {
      state.loading = IDLE;
      state.data = action.payload;
    });
    builder.addCase(getSystemSnapshotsRangeThunk.rejected, (state, action) => {
      state.loading = IDLE;
      state.error = action.error?.message || 'Unknown error';
    });
  },
});

export const compareState = (state: RootState) => state.compare;
export default compareSlice.reducer;
